let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9kt1f")).then(() => parcelRequire('8CPhJ'));